// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#content{height:100%}*{box-sizing:content-box}#body-public #app-navigation ul{margin-bottom:70px}#body-public #app-navigation footer{display:block;position:absolute;bottom:0;width:100%;background-color:var(--color-main-background);z-index:100;height:65px}\n", ""]);
// Exports
module.exports = exports;
